<template>
  <div class="container">
    <iframe :src="ifr" frameborder="0"></iframe>
    <ul class="aside">
      <li @click="handleItem(item)" v-for="(item,i) in aside" :key="i" class>
        <img :src="`${$cdn}aside/${item.name}.png`" alt />
      </li>
    </ul>

    <div class="swiper-mask" @click="listVisable = false" v-show="listVisable"></div>
        <listSwiper
              v-if="listVisable"
              @close="()=>{listVisable = false}"
              @msgsActive="handleMsgs"
              :activeType="activeType"
            />
    </div>
</template>

<script>
import listSwiper from "@/components/listSwiper";

const aside = [
  {
    id: "",
    name: "hdzy"
  },
  {
    id: "",
    name: "cjxz"
  },
  {
    id: "",
    name: "uic"
  }
];
export default {
  name: "Home",
  data() {
    return {
      active: false,
      aside,
      listVisable: false,
      detailVisable: false,
      activeType: "",
      activeDetail: "",
      musicSta: !this.$route.query.noMusic,
      mus: ""
    };
  },
  watch: {
    musicSta(val) {
      this.$emit('audio',val)
    },
    '$route.query.noMusic':function (val) {
      this.musicSta = !val
    }
  },
  computed: {
    ifr() {
      let { ifr } = this.$route.query;
      let iframe = ifr ? ifr : "https://houseoss.4dkankan.com/uic/UICcode/hp1/tour.html";
      return iframe;
    },
    titleImg() {
      let { ifr } = this.$route.query;

      return !ifr
        ? `${this.$cdn}title/FKQAD.png`
        : ``;
    }
  },
  components: {
    listSwiper
  },
  methods: {
    handleMsgs(data) {
      this.detailVisable = true;
      this.activeDetail = data.item;
    },
    handleItem(item) {
      if (item.name === "hdzy") {
        this.$emit('audio',false)
        return this.$router.push({ path: "/" });
      }

      if (item.name === "uic") {
        return window.open('https://uic.edu.cn/en/','_blank')
      }
     
      this.listVisable = true;
      this.activeType = item.name;
    }
  },
  mounted() {
   
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  iframe {
    width: 100%;
    height: 100%;
  }
 
  .aside {
    position: fixed;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    li {
      cursor: pointer;
      img {
        width: 100px;
      }
    }
  }
  .swiper-mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    .btn {
      position: absolute;
      right: 10px;
      top: 10px;
      background: #fb3802;
      border-radius: 4px;
      line-height: 30px;
      height: 30px;
      color: #fff;
      display: inline-block;
      padding: 0 10px;
      width: 80px;
      text-align: center;
      z-index: 999999;
    }
  }

  .detail {
    z-index: 6666;
    background: rgba(0, 0, 0, 1);
  }

  .musicicon {
    position: fixed;
    left: 10px;
    bottom: 10px;
    img {
      width: 40px;
      height: auto;
    }
  }
}
@media screen and (max-width: 500px) {
  .container {
    max-width: 500px;
    .aside {
      li {
        img {
          width: 70px;
        }
      }
    }
  }
}
</style>